import { Component, Input, OnInit } from '@angular/core';
import { Course } from '@core/models/course.model';

@Component({
  selector: 'app-single-course-card-wide',
  templateUrl: './single-course-card-wide.component.html',
  styleUrl: './single-course-card-wide.component.css',
})
export class SingleCourseCardWideComponent implements OnInit {
  @Input() course!: Course;
  isEnrolled = false;
  isCompleted = false;
  isExpiringSoon = false;
  courseProgress = 0;
  creditHourLabel = '';
  availableDateRange = '';
  creditOfferedText = '';

  ngOnInit(): void {
    if (this.course?.expired_at) {
      const expiryDate = new Date(this.course.expired_at).getTime();
      const currentDate = new Date().getTime();
      const daysUntilExpiry = Math.floor((expiryDate - currentDate) / (1000 * 60 * 60 * 24));
      this.isExpiringSoon = daysUntilExpiry >= 0 && daysUntilExpiry <= 30;
    }

    const credit = this.course?.completion_time ?? null;
    if (credit !== null) {
      this.creditHourLabel = `${credit} hour${credit > 1 ? 's' : ''}`;
    } else {
      this.creditHourLabel = '-';
    }

    if (this.course?.released_at && this.course?.expired_at) {
      const release = new Date(this.course.released_at);
      const expiry = new Date(this.course.expired_at);
      this.availableDateRange = `${this.formatDate(release)} – ${this.formatDate(expiry)}`;
    }

    const creditArray = this.course?.courseCreditType as string[] | null;
    this.creditOfferedText =
      Array.isArray(creditArray) && creditArray.length ? creditArray.join(', ') : '';
  }

  private formatDate(date: Date): string {
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: '2-digit',
      year: 'numeric',
    });
  }
}
